import { useBreakpointDown, useBreakpointUp } from '@travel-frontend/core';
import { findKey } from 'lodash';
export const usePhoneNumber = config => {
  const smDown = useBreakpointDown('sm');
  const mdUp = useBreakpointUp('md');
  const lgUp = useBreakpointUp('lg');
  const currentDeviceKey = findKey({
    phone: smDown,
    tablet: mdUp && !lgUp,
    desktop: lgUp
  }, active => active === true);
  // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
  return typeof config === 'string' ? config : config[currentDeviceKey];
};